import { SET_IS_READY } from '@redux/actions/types'

const initialState = {
  appIsReady: false,
  chatIsReady: false,
  accountConfigIsReady: false,
  userConfigIsReady: false
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
  case SET_IS_READY:
    return {
      ...state,
      ...payload
    }
  default:
    return state
  }
}

export default reducer
